import e from"styled-components";import{theme as r}from"../../../theme.js";const t=a=>{switch(a.varinat){case"gray":return r.colors.gray[50];case"white":return r.colors.shades[0];case"default":return r.colors.secondary[900];default:return r.colors.secondary[900]}},n=a=>{switch(a.varinat){case"gray":return r.colors.gray[900];case"white":return r.colors.gray[900];case"default":return r.colors.shades[0];default:return r.colors.shades[0]}},s=a=>{switch(a.varinat){case"gray":return r.colors.gray[600];case"white":return r.colors.gray[600];case"default":return r.colors.shades[0];default:return r.colors.shades[0]}},o=e.div`
  border-radius: ${r.radius}px;
  padding: ${r.spacing*6}px;
  display: flex;
  flex-direction: column;
  gap: ${r.spacing*6}px;
  background-color: ${({varinat:a})=>t({varinat:a})};
`,i=e.span`
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  margin: 0;
  color: ${({varinat:a})=>n({varinat:a})};
`,c=e.span`
  line-height: 32px;
  color: ${({varinat:a})=>s({varinat:a})};
  margin: 0;
`,l=e.div`
  display: flex;
  justify-content: space-between;
  gap: ${r.spacing*4}px;
  > button {
    width: 100%;
  }
  @media screen and (max-width: ${r.breakpoints.md}) {
    flex-direction: column;
  }
`,d=e.div`
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: ${r.spacing*2}px;
  align-items: center;
`;export{l as ButtonsContainer,o as Container,c as Description,d as HeaderContainer,i as Title};
